export default __webpack_public_path__ + "static/media/banner2.94b882b0.jpg";